module.exports = __webpack_public_path__ + "img/apple_logo_black.02031275.svg";